import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: "border-box",
  },
  mainContainer: {
    width: "100%",
    margin: "0px",
    padding: "5%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor:"white"
  },
  mainHeading: {
    marginTop:"5%",
    fontSize: "30px",
    color: "#1FA19D",
    fontFamily:
      "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
    fontWeight: "bold",
  },
  subHeading:{
    marginTop:"2%",
    fontSize: "20px",
    color: "#4A618A",
    fontFamily:
      "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
    fontStyle:"italic",
    textAlign:"center"
  },
  ListItemButton:{
    backgroundColor: "#f1d5fa!important", 
    borderLeft:"3px solid #1FA19D!important", 
    borderRight:"3px solid #1FA19D!important", 
  },
  SubmitBtn:{
    width: "50px",
    height:"50px",
    marginTop:"5%",
    backgroundColor:"#1FA19D",
    color:"white",
    cursor:"pointer",
    border:"none",
    borderRadius:"50%",
    
    fontSize:"25px",
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    transition:"0.2s ease-in-out",
    "&:hover":{
      boxShadow:"0px 0px 10px 0.3px grey"
    }
  },


  "@media only screen and (max-width:500px)":{
    
      mainHeading:{
        fontSize:"20px"
      }
    
  },

  "@media only screen and (max-width:320px)":{
    
    mainHeading:{
      fontSize:"18px"
    }
  
}

}));

export default useStyles;
